var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmp = function SvgAmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99745 7.43987L9.26136 1.56746C10.0633 0.815649 10.4642 0.439745 10.7445 0.419338C10.986 0.401757 11.2211 0.483933 11.3584 0.633902C11.5179 0.807974 11.392 1.28002 11.1402 2.22411L9.73334 7.49997L12.0268 7.26753C12.851 7.18399 13.2631 7.14222 13.4712 7.24436C13.6516 7.33294 13.7637 7.48149 13.7722 7.64309C13.7819 7.82943 13.5221 8.07298 13.0026 8.56008L6.73865 14.4325C5.93672 15.1843 5.53576 15.5602 5.2555 15.5806C5.01405 15.5982 4.77892 15.516 4.64156 15.366C4.48214 15.192 4.60802 14.7199 4.85977 13.7758L6.26667 8.49997L3.97323 8.73242C3.14899 8.81596 2.73687 8.85772 2.52884 8.75559C2.34843 8.66701 2.23629 8.51846 2.22783 8.35686C2.21809 8.17052 2.47787 7.92697 2.99745 7.43987Z",
    fill: "url(#paint0_linear_807_608)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_608",
    x1: 2,
    y1: 15.3333,
    x2: 2.00001,
    y2: 0.666666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419774,
    stopColor: "#DB00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })))));
};
export default SvgAmp;